import React from 'react';
import { Tabs, Tab } from 'plaid-threads/Tabs';

import './index.scss';
import CreateConsent from './CreateConsent';
import ExecutePayment from './ExecutePayment';

interface ConsentsProps {}

const Consents: React.FC<ConsentsProps> = () => {
  const [createdConsentId, setCreatedConsentId] = React.useState<string | null>(null);
  const [selectedTabIndex, setSelectedTabIndex] = React.useState<number>(0);

  function onConsentCreated(consentId: string) {
    setCreatedConsentId(consentId);
  }

  React.useEffect(() => {
    if (!createdConsentId) {
      return;
    }

    setSelectedTabIndex(1);
  }, [createdConsentId]);

  return (
    <div className="Consents">
      <div className="Consents__title">Variable Recurring Payment</div>
      <Tabs onChange={(index) => setSelectedTabIndex(index)} selectedIndex={selectedTabIndex}>
        <Tab title="Create consent">
          <CreateConsent onCreated={onConsentCreated} />
        </Tab>
        <Tab title="Execute payment">
          <ExecutePayment consentId={createdConsentId} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Consents
